<template>
	<div class="projectDetail-container">
		<div v-loading="loading" class="project-detail-content">
			<!-- 详情-表格数据 -->
			<div class="common-detail-table">
				<table>
					<colgroup>
						<col width="180" />
						<col />
						<col width="180" />
						<col />
					</colgroup>
					<tr>
						<th>项目名称</th>
						<td colspan="3">{{ projectCompletionDetail.projectName }}</td>
					</tr>
					<tr>
						<th>工程名称</th>
						<td colspan="3">{{ projectCompletionDetail.engineeringName }}</td>
					</tr>
					<tr>
						<th>长度(米)</th>
						<td>{{ projectCompletionDetail.length }}</td>
						<th>跨度(米)</th>
						<td>{{ projectCompletionDetail.span }}</td>
					</tr>
					<tr>
						<th>竣工验收环节编码</th>
						<td>{{ projectCompletionDetail.linkCode }}</td>
						<th>施工许可证编号</th>
						<td>{{ projectCompletionDetail.constructionPermitLinkCode }}</td>
					</tr>
					<tr>
						<th>实际造价(万元)</th>
						<td>{{ projectCompletionDetail.actualMoney }}</td>
						<th>实际面积(平方米)</th>
						<td>{{ projectCompletionDetail.actualArea }}</td>
					</tr>
					<tr>
						<th>实际建设规模</th>
						<td>{{ projectCompletionDetail.actualDesignScale }}</td>
						<th>结构体系</th>
						<td>{{ projectCompletionDetail.structuralSystemName }}</td>
					</tr>
					<tr>
						<th>实际开工日期</th>
						<td>{{ projectCompletionDetail.startTime }}</td>
						<th>实际竣工日期</th>
						<td>{{ projectCompletionDetail.endTime }}</td>
					</tr>
					<tr>
						<th>备注</th>
						<td colspan="3">{{ projectCompletionDetail.remark }}</td>
					</tr>
				</table>
			</div>
		</div>
		<!-- 未开通会员提示 -->
		<nonbind-vip v-if="isVip"></nonbind-vip>
		<!-- 未开通超级会员提示 -->
		<nonbind-svip v-if="isSVip"></nonbind-svip>
	</div>
</template>

<script>
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import NonbindSvip from '@/components/NonBind/nonbindSVip.vue'
	import { transObject } from '@/utils/index'
	import { getProjectCompletionDetail } from '@/api/qualificationQuery/project'

	// 竣工验收详情
	export default {
		name: 'AcceptanceDetails',
		components: { NonbindVip, NonbindSvip },
		props: {
			id: {
				type: String,
				required: true,
				default: ''
			}
		},
		data() {
			return {
				// 数据加载状态
				loading: false,
				isVip: false,
				isSVip: false,
				// 竣工验收详情对象
				projectCompletionDetail: {
					// 项目名称
					projectName: '',
					// 工程名称
					engineeringName: '',
					// 长度
					length: '',
					// 跨度
					span: '',
					// 竣工验收环节编码
					linkCode: '',
					// 施工许可证编号
					constructionPermitLinkCode: '',
					// 实际造价
					actualMoney: '',
					// 实际面积
					actualArea: '',
					// 实际建设规模
					actualDesignScale: '',
					// 结构体系
					structuralSystem: '',
					structuralSystemName: '',
					// 实际开工日期
					startTime: '',
					// 实际竣工日期
					endTime: '',
					// 备注
					remark: ''
				},
				message: ''
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.handleQueryProjectCompletionDetail()
		},
		methods: {
			// 查询合同登记详情
			handleQueryProjectCompletionDetail() {
				this.loading = true
				const params = {
					projectCompletionId: this.id
				}

				getProjectCompletionDetail(params)
					.then(response => {
						const { data, code, message } = response

						if (code === 6102) {
							this.isVip = true
						} else if (code === 6104) {
							// 当前是svip 权益已经使用完，提示次数已经用完了，请等待会员权益重置再使用
							this.$message.warning(message)
						} else if (code === 6105) {
							// 当前是vip 权益已经使用完，提示次数已经用完了，请用户升级为svip
							this.isSVip = true
						} else {
							if (data) {
								// 将目标数据转为我指定的属性对象
								transObject(data, this.projectCompletionDetail)
							}
						}
						this.loading = false
					})
					.catch(error => {
						this.loading = false
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/table.scss';
	@import '../../styles/project.scss';
</style>
